import { USER_AUTH } from "./actionTypes";

export function loginAction(value) {
  return {
    type: USER_AUTH,
    payload: value,
  };
}
